import type { FieldTree } from '@angular/forms/signals';
import { readonly } from '@angular/forms/signals';

import type { AnimationSettings } from '@sites/entity-core';
import { animationFeature } from '@sites/entity-core';

// Thunk is mandatory: the form model starts as { data: null }, so the
// animation FieldTree node does not exist until the entity is synced.
export const createAnimationAccessors = (getField: () => FieldTree<AnimationSettings>) => ({
    get animation() {
        return getField();
    },
    // version is stamped by the form; callers never manage it
    setAnimation: (value: Omit<AnimationSettings, 'version'>) => {
        getField()().value.set({ ...value, version: animationFeature.latestVersion });
    },

    get animationIsActive() {
        return getField().isActive;
    },
    setAnimationIsActive: (value: boolean) => {
        getField().isActive().value.set(value);
    },
    toggleAnimationIsActive: () => {
        const current = getField().isActive().value();
        getField().isActive().value.set(!current);
    },

    get animationType() {
        return getField().animationType;
    },
    setAnimationType: (value: AnimationSettings['animationType']) => {
        getField().animationType().value.set(value);
    },

    get animationPosition() {
        return getField().animationPosition;
    },
    setAnimationPosition: (value: AnimationSettings['animationPosition']) => {
        getField().animationPosition().value.set(value);
    },

    get animationSpeed() {
        return getField().animationSpeed;
    },
    setAnimationSpeed: (value: AnimationSettings['animationSpeed']) => {
        getField().animationSpeed().value.set(value);
    },
});

export type AnimationAccessors = ReturnType<typeof createAnimationAccessors>;

// Schema-path rules: keep the nested feature version read-only, like schemaPath.version at entity level.
export const applyAnimationFieldRules = (animationPath: any): void => {
    readonly(animationPath.version);
};
